<template>
    <div 
        :id="id"
        class="lightbox-container d-flex flex-column align-items-center hidden"
        :class="lightboxClasses"
    >
        <div
          class="d-flex justify-content-end mt-2 close-button"
        >
            <i
                class="material-icons"
                style="color: #fff; font-size: 40px"
                @click.prevent="onCloseButtonPressed"
            >close</i>
        </div>
        <div
          class="flex-grow-1 d-flex flex-column justify-content-center image-container"
          :style="`background-image: url(${images[activeImageIndex]})`"
        >
        </div>
        <lightbox-image-list 
            v-model:active-image-index="activeImageIndex"
            :images="images"
        />
    </div>
</template>

<script>
//import LightboxFocusImage from './Components/LightboxFocusImage.vue';
import LightboxImageList from './Components/LightboxImageList.vue';

export default {
    components: {
       //LightboxFocusImage,
      LightboxImageList,
    },

    props: {
        id: { type: String, default: 'defaultLightbox' },
        images: { type: Array, required: true },
        initialIndex: { type: Number, default: 0 }
    },

    data() {
        return {
            activeImageIndex: this.initialIndex,
            hidden: true,

            eventKeyCodeMap: {
                closeLightbox: [
                    27, // Escape
                ],
                previousImage: [
                    37, // Arrow Reft
                    65, // A
                ],
                nextImage: [
                    39, // Arrow Right
                    68, // D
                ]
            }
        };
    },

    computed: {
        lightboxClasses() {
            return {
                'd-flex': !this.hidden,
                'd-none': this.hidden,
            }
        }
    },

    mounted() {
        if (this.images.length < 1) return;
        if (this.activeImageIndex < 0 || this.activeImageIndex > this.images.length - 1) {
            console.error("Lightbox: Active image index out of bounds");
        }
    },

    methods: {
        show(index = 0) {
            this.activeImageIndex = index;
            this.hidden = false;

            document.addEventListener('keydown', this.onKeyPressed);
        },

        hide() {
            document.removeEventListener('keydown', this.onKeyPressed);
            this.hidden = true;
        },

        previousImage() {
            if (this.activeImageIndex < 1) {
                this.activeImageIndex = this.images.length - 1;
                return;
            }

            this.activeImageIndex -= 1;
        },

        nextImage() {
            if (this.activeImageIndex == this.images.length - 1) {
                this.activeImageIndex = 0;
                return;
            }

            this.activeImageIndex += 1;
        },

        onKeyPressed(e) {
            if (this.eventKeyCodeMap['closeLightbox'].includes(e.keyCode)) {
                this.hide();
            }
            
            if (this.eventKeyCodeMap['previousImage'].includes(e.keyCode)) {
                this.previousImage();
            }

            if (this.eventKeyCodeMap['nextImage'].includes(e.keyCode)) {
                this.nextImage();
            }
        },

        onCloseButtonPressed() {
            this.hide();
        }
    }
}
</script>

<style lang="scss" scoped>
.lightbox-container {
    position: fixed;
    top: 0;
    left: 0;
    background:#00000088;
    width: 100%;
    height: 100%;
    z-index: 9999;
}

.close-button {
    user-select: none;
    cursor: pointer;
}

.image-container {
	width: 100%;
	background-size: contain;
	background-repeat: no-repeat;
	background-position-x: center;
}
</style>